<div *ngIf="message" class="alert-bar-container p-2">
  <div class="container inner-container d-flex">
    <span class="exclamation-symbol">
      <svg-icon key="exclamation-mark"></svg-icon>
    </span>
    {{ message }}
  </div>
</div>
